"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsonapi_1 = require("../HttpClient/jsonapi");
class Email {
    constructor(client) {
        this._encryption = false;
        this._dataUrl = client.applicationUrl + "/services/notification/email";
        this._jsonApiClient = client._jsonApiClient;
        const encryptionOptions = client.options.payloadEncryption;
        if (encryptionOptions && encryptionOptions.enforcement.includes("COMMON")) {
            this._encryption = true;
        }
    }
    send(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._jsonApiClient.request("POST", this._dataUrl, {
                    data: payload,
                    encryption: this._encryption,
                });
                return yield (0, jsonapi_1.deserialize)(response.data);
            }
            catch (error) {
                return error;
            }
        });
    }
    getTemplates() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._jsonApiClient.request("GET", this._dataUrl, {
                    encryption: this._encryption,
                });
                return yield (0, jsonapi_1.deserialize)(response.data);
            }
            catch (error) {
                return error;
            }
        });
    }
}
exports.default = Email;
